module.exports = __webpack_public_path__ + "img/PIN_13_68_Firmentreuemichijpg.jpg";